import { Turbo } from '@hotwired/turbo-rails'

Turbo.StreamActions.advance_history = function() {
  history.replaceState({}, "", this.target)
}

Turbo.StreamActions.full_redirect = function() {
  Turbo.visit(this.target)
}